/** @type {import('tailwindcss').Config} */
export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  important: '#root',
  theme: {
    fontFamily: {
      sans: ['Manrope Variable', 'Helvetica', 'Arial', 'sans-serif'],
    },
    extend: {
      colors: {
        black: '#000000',
        white: '#ffffff',
        blue: {
          DEFAULT: '#315dff',
          light: '#7bb4ff',
          lightest: '#abd3ff',
        },
        yellow: {
          DEFAULT: '#fdd503',
          light: '#fdd503',
          lightest: '#fff5ca',
        },
        green: {
          DEFAULT: '#29b701',
          light: '#82d663',
          lightest: '#c8f2bb',
        },
        pink: {
          DEFAULT: '#ff3399',
          light: '#ff76c1',
          lightest: '#f9cde5',
        },
        danger: {
          DEFAULT: '#ff0000',
        },
        gray: {
          DEFAULT: '#808080',
        },
      },
    },
  },
  plugins: [],
}
